var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotorAsincronTrifazatCuRotorulInScurtcircuitStea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 80,
    viewBox: "0 0 76 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 40C2 20.1177 18.1177 4 38 4C57.8823 4 74 20.1177 74 40C74 59.8823 57.8823 76 38 76C18.1177 76 2 59.8823 2 40Z",
    fill: "white",
    stroke: "#FC7900",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4656 39.9375L54.5143 49.2032",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6289 26.3711L62.419 31.926",
    stroke: "black",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.739 25.1267L61.3416 32.5859",
    stroke: "black",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2642 22.1992L38.2642 40.4796",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6495 49.0791L38.3455 39.7032",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9998 15.0007C63.9999 14.5001 61.861 29.8096 62.5001 31.5",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorAsincronTrifazatCuRotorulInScurtcircuitStea);
export default __webpack_public_path__ + "static/media/motor_asincron_trifazat_cu_rotorul_in_scurtcircuit_stea.0d84895a9f4c09b9bd5390b0179fe0cd.svg";
export { ForwardRef as ReactComponent };